/**
 *  button click analytics button types
 */

export enum ButtonClickAnalyticsType {
    CREATE = 1,
    FILTER = 2,
    SEARCH = 3,
    EXPORT = 4,
    NAVIGATE = 5,
    SCHEDULE = 6,
    INSERT = 7,
    CHOOSE = 8,
    LAUNCH = 9,
    OPEN = 10,
    SEND = 11,
    INVITE = 12,
    CLOSE = 13,
    SAVE = 14,
    EXPAND = 15,
    COLLAPSE = 16,
    EDIT = 17,
    DELETE = 18,
    BROWSE = 19,
    LOAD = 20,
    ADD = 21,
    MENU = 22,
    REGISTER = 23,
    LOGIN = 24,
    LINK = 25,
    TOGGLE = 26,
    THUMBNAIL = 27,
    DOWNLOAD = 28,
    SHARE = 29,
}
